// Single chat bubble + typing indicator (3-dot animation).
import React from "react";

export const ChatMessageBubble = ({ message }) => {
  const isUser = message.role === "user";
  const text = message.display || message.content;
  if (!text) return null;
  return (
    <div
      className={`flex ${isUser ? "justify-end" : "justify-start"}`}
      data-testid={isUser ? "ai-chat-bubble-user" : "ai-chat-bubble-assistant"}
    >
      <div
        className="rounded-lg px-3.5 py-2.5"
        style={{
          maxWidth: "78%",
          background: isUser ? "#185FA5" : "#0d0f18",
          border: isUser ? "1px solid #185FA5" : "1px solid rgba(255,255,255,0.08)",
          color: isUser ? "#fff" : "#cfd1d8",
          fontFamily: "'DM Mono', monospace",
          fontSize: 13,
          lineHeight: 1.55,
          whiteSpace: "pre-wrap",
        }}
      >
        {text}
      </div>
    </div>
  );
};

// ---------------- Typing indicator ----------------
export const ChatTypingIndicator = () => (
  <div className="flex justify-start" data-testid="ai-chat-typing">
    <div
      className="rounded-lg px-3.5 py-3 flex items-center gap-1"
      style={{ background: "#0d0f18", border: "1px solid rgba(255,255,255,0.08)" }}
    >
      <span className="ai-dot" style={dotStyle(0)} />
      <span className="ai-dot" style={dotStyle(150)} />
      <span className="ai-dot" style={dotStyle(300)} />
      <style>{`
        @keyframes ai-bounce {
          0%, 80%, 100% { opacity: 0.3; transform: translateY(0); }
          40% { opacity: 1; transform: translateY(-4px); }
        }
      `}</style>
    </div>
  </div>
);
const dotStyle = (delay) => ({
  width: 6,
  height: 6,
  borderRadius: "50%",
  background: "#9ec3ec",
  display: "inline-block",
  animation: "ai-bounce 1.2s ease-in-out infinite",
  animationDelay: `${delay}ms`,
});

